import React, { useEffect, useMemo } from 'react';
import { ShouldRender } from '../../ui-core/ShouldRender';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../constants/app';
import './style.css';
import Button from '../../ui-core/Button/Button';
import OfflineCartItem from './OfflineCartItem';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { getPageName } from '../../utils/helpers';
import { APP_ROUTES } from '../../route';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { doFetchLoggedOutCartRequest } from '../../store/action/checkout';
import { getItem } from '../../utils/cache';
import { extractJSON } from '../../services/jsonUtil';

const OfflineCartOffCanvas = ({ props, setIsOpen, isOpen, OfflineCart }) => {
  const dispatch = useDispatch();
  const handleClose = () => setIsOpen(!isOpen);
  const history = useHistory();
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  // const handleCheckout = () => {
  //   setItem('isOfflineCheckout', true);
  //   props?.onClick('LOGIN', 'isLogin', 'navigation header');
  // };
  const { cart } = useSelector(state => state.checkout);
  const page = useMemo(() => {
    return getPageName(history.location.pathname);
  }, [history?.location?.pathname]);

  const handleClick = () => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: 'Cart Icon',
      page,
      section_title: 'Cart Offcanvas Header',
    });
    handleClose();
    if (history.location.pathname !== APP_ROUTES.BUNDLE_DEALS) {
      history.push(APP_ROUTES.BUNDLE_DEALS);
    }
  };
  const cartItems = useMemo(() => {
    if (!cart) return [];
    return cart?.attributes?.selected || [];
  }, [cart]);

  const itemsCount = useMemo(() => {
    return cartItems?.length || 0;
  }, [cartItems]);

  useEffect(() => {
    if (!user) {
      fetchCartData2();
    }
  }, [OfflineCart]);

  const fetchCartData2 = async () => {
    let products = [];
    const OfflineCartData = JSON.parse(getItem('offlineCart'));
    if (OfflineCartData?.length) {
      products = OfflineCartData.map(item => item?.attributes?.product_id);
    }
    console.log('products', products);
    dispatch(doFetchLoggedOutCartRequest());
  };

  return (
    <ShouldRender check={isOpen}>
      <div className="off-canvas">
        <div className="off-canvas-backdrop" onClick={handleClose}></div>
        <div className="off-canvas-body">
          <div className="image-cross">
            <img
              alt="closeIcon"
              src={IMAGE_CONSTANT.crossIcon}
              onClick={handleClose}
            />
          </div>
          <div className="header">
            <img
              className="back-icon"
              onClick={handleClose}
              src={IMAGE_CONSTANT.backIcon}
            />
            <div className="off-canvas-title">Your Cart</div>
            <div className="cart-icon">
              <img
                alt="cart"
                className="cursor-pointer"
                src={IMAGE_CONSTANT.shoppingCartIcon}
                onClick={handleClose}
              />
              <ShouldRender check={OfflineCart?.length > 0}>
                <span className="items-count">{OfflineCart?.length}</span>
              </ShouldRender>
            </div>
          </div>
          <ShouldRender check={OfflineCart?.length === 0}>
            <div className="off-canvas-container">
              <img
                src={IMAGE_CONSTANT.emptyCartIcon}
                alt="empty cart"
                className="mb-4"
              />
              <p>There are no items in your cart</p>
              <Button
                text="ADD ITEMS"
                onClick={handleClick}
                class="sign-up-button-new text-uppercase mt-2 w-auto px-3"
              />
            </div>
          </ShouldRender>
          <ShouldRender check={OfflineCart?.length > 0}>
            <div className="cart-items-wrapper">
              <OfflineCartItem selectedProducts={OfflineCart} />
            </div>
            <div className="checkout-wrapper mt-2">
              {/* JW-204 */}
              <Button
                text={`View Cart ${itemsCount ? ' (' + itemsCount + ')' : ''} `}
                onClick={handleClick}
                class="view-button w-full"
                style={{ width: '100%', padding: '11px' }}
              />
              {/* <Button
                text="CHECKOUT"
                onClick={handleCheckout}
                class="sign-up-button-new"
              //   isLoading={isLoading}
              //   isDisabled={isLoading}
              /> */}
            </div>
          </ShouldRender>
        </div>
      </div>
    </ShouldRender>
  );
};

OfflineCartOffCanvas.propTypes = {
  setIsOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  OfflineCart: PropTypes.array,
  props: PropTypes.object,
  onClick: PropTypes.func,
};

export default OfflineCartOffCanvas;
